import { http } from 'utils'
import { SET_ITEMS, ADD_ITEMS } from 'vx/mutations'
import { concat } from 'lodash'

export default {
  namespaced: true,

  state: {
    products: []
  },

  actions: {
    async getProducts ({ commit }, { params = {} } = {}) {
      const response = await http.get('lists/products')

      commit(ADD_ITEMS, response.data.data)

      return response
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.products = items
    },

    [ADD_ITEMS] (state, items) {
      state.products = concat(state.products, items)
    }
  }
}
